







































































































































import { Component, Vue } from "vue-property-decorator";
/** TSでbeginElementが用意されていないので追加 */
interface SVGElement extends Element {
  beginElement(): SVGElement;
}
@Component
export default class SoulAttractComponent extends Vue {
  readonly w = 792;
  readonly h = 792 * 1.5;
  xys = [
    { x: (this.w * 2) / 3, y: this.h / 3 },
    { x: this.w / 5, y: this.h / 4 },
    { x: (this.w * 4) / 5, y: (this.h * 2) / 3 },
    { x: this.w / 4, y: (this.h * 4) / 5 },
  ];
  mounted() {
    const shortMS = 300;
    const longMS = 300;
    const smallHamonMS = 100;
    const refs = this.xys.map((_, i) => [
      this.$refs[`1_${i}`],
      this.$refs[`1_after_${i}`],
      this.$refs[`2_${i}`],
      this.$refs[`2_after_${i}`],
    ]);
    // 短い間隔の波紋
    refs.forEach((v, i) => {
      setTimeout(() => {
        (v[0] as SVGElement[])[0]?.beginElement();
        (v[1] as SVGElement[])[0]?.beginElement();
      }, shortMS * i);
      setTimeout(() => {
        (v[2] as SVGElement[])[0]?.beginElement();
        (v[3] as SVGElement[])[0]?.beginElement();
      }, shortMS * i + smallHamonMS);
    });
    // 最後の波紋は長い間隔
    const lastRefs = [
      this.$refs["1_last"],
      this.$refs["1_after_last"],
      this.$refs["2_last"],
      this.$refs["2_after_last"],
    ];
    setTimeout(() => {
      (lastRefs[0] as SVGElement)?.beginElement();
      (lastRefs[1] as SVGElement)?.beginElement();
    }, shortMS * this.xys.length + longMS);
    setTimeout(() => {
      (lastRefs[2] as SVGElement)?.beginElement();
      (lastRefs[3] as SVGElement)?.beginElement();
      // フェードアウトさせつつ
      this.$emit("done");
    }, shortMS * this.xys.length + longMS + smallHamonMS);
  }
}
